
/**
 * 获取URL上的参数
 * @param {*} name 需要取得参数名字
 * @returns 
 */
export function queryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return unescape(r[2]);
    }
    return null;
}